module.exports = __webpack_public_path__ + "img/icon_sm_wlzhsp.d9472cc9.png";